import { render, staticRenderFns } from "./SimulationType.vue?vue&type=template&id=3ad6f5d6&"
import script from "./SimulationType.vue?vue&type=script&lang=js&"
export * from "./SimulationType.vue?vue&type=script&lang=js&"
import style0 from "./SimulationType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports